import Vue from 'vue';
import { mutationTypes, getterTypes, actionTypes } from '@/types';
import { logger } from '@/tools';

export default {
	state: {
		active: false,
		current: null,
		// quizTourID: null,
		questions: {},
		visitedPages: {},
	},
	getters: {
		[getterTypes.quizCurrentStoreObject](state) {
			return state.questions;
		},

		[getterTypes.quizResult](state) {
			if (state.active == false) return { correct: null, count: null };
			const curQuiz = state.questions;

			let correct = 0;
			for (let i in curQuiz) {
				const answeredRight = curQuiz[i].result;
				if (answeredRight === true) correct++;
			}
			return { correct, count: Object.keys(curQuiz).length };
		},
	},
	mutations: {
		/**
		 * init tutorial state
		 * @param {*} state
		 * @param { exhibitions } all exhibitions of dataSource
		 */
		[mutationTypes.quizInit](state, { quizzes }) {
			logger.log('#quiz tour init.', mutationTypes.quizInit, '() state.questions =', quizzes);
			// state.questions = quizzes;
		},

		/**
		 * commit for setting quiz state
		 * @param {*} state
		 * @param { quizID, active } options quizID sets current quiz
		 *
		 */
		[mutationTypes.quizStart](state, { quizId }) {
			logger.log('#quiz tour start.', quizId);
			state.active = true;
			state.current = quizId;
			state.visitedPages = {};
			state.questions = {}; // clear user answeres
		},
		/**
		 * commit for ending quiz
		 * @param {*} state
		 * @param {  } options
		 *
		 */
		[mutationTypes.quizEnd](state) {
			logger.log(
				'#quiz end quiz for exhibition.',
				mutationTypes.quizEnd,
				'() state.active = false; state.current = null'
			);
			state.active = false;
			state.current = null;
			state.questions = {};
			state.visitedPages = {};
		},

		[mutationTypes.quizCollectQuestions](state, { questions }) {
			logger.log('#quiz quizCollectQuestions: ', questions);

			Object.entries(questions).forEach(([key, value]) => {
				if (state.questions[key]) return;
				state.questions[key] = value;
			});
			// activate vue's reactivity system after possible adding new propterties to the question object
			state.questions = { ...state.questions };
		},

		[mutationTypes.quizStoreResult](state, { questionID, answersObj }) {
			logger.log('#quiz quizStoreResult: questionID', questionID);
			let answeredRight = 0;
			let rightAnswers = 0;
			let answeredWrong = 0;
			for (let j in answersObj) {
				let curAnswer = answersObj[j];
				if (curAnswer.answerCorrect === true) rightAnswers++;
				if (curAnswer.answerSelected) {
					if (curAnswer.answerCorrect === true) answeredRight++;
					else answeredWrong++;
				}
			}
			let result = answeredRight == rightAnswers && answeredWrong == 0;

			state.questions[questionID].result = result;
			state.questions[questionID].answers = answersObj;
			// activate vue's reactivity system after possible adding new propterties to the question object
			state.questions = { ...state.questions };
		},
		[mutationTypes.quizSetArticleToVisited](state, { articleID }) {
			Vue.set(state.visitedPages, articleID, true);
		},
	},
	plugins: [
		store => {
			/**
			 * Plugin collects all tours that are quizzes
			 */
			store.subscribe((mutation, state) => {
				if (mutation.type === mutationTypes.swipeSetArticleProperties) {
					if (!state.quiz.visitedPages[state.currentArticleID]) {
						Vue.nextTick(() =>
							// use next tix to prevent setting contentUI attributes on the first load as not visited
							store.commit(mutationTypes.quizSetArticleToVisited, {
								articleID: state.currentArticleID,
							})
						);
						if (state.quiz.active && state.tour.position > 0) {
							store.dispatch(actionTypes.contentModalSet, {
								articleID: state.tour.current.exhibitIDs[state.tour.position - 1].articleID,
								exhibitionID: state.currentExhibitionID,
								tourID: state.tour.current._id,
								buttons: [
									{
										name: 'next',
										class: '',
										place: 'modal',
										showIn: '*',
										url: '[function]',
										contentID: 'next',
										click: () => {
											store.dispatch(actionTypes.closeModal);
										},
									},
								],
								noContentInteraction: true,
								close: true,
							});
						}
					}
				}
				// on initialization of tours. collect tours that are quizzes
				else if (mutation.type === mutationTypes.tourInit) {
					const all = Object.values(state.tour.toursMap).reduce((acc, tour) => {
						if (tour.isQuiz) {
							// create all quizzes object
							acc[tour._id] = {};
						}
						return acc;
					}, {});
					store.commit(mutationTypes.quizInit, { quizzes: all });
				}
				// if a tour article is started. activate quiz if tour is quiz
				else if (mutation.type === mutationTypes.tourSetCurrent) {
					if (
						state.tour.current.isQuiz &&
						(!state.quiz.active || (state.quiz.active && state.quiz.current !== state.tour.current._id))
					) {
						store.commit(mutationTypes.quizStart, { quizId: state.tour.tourCurrentID });
					}
					// else store.commit(mutationTypes.quizEnd, {})
				} else if (mutation.type === mutationTypes.tourEnd) {
					if (state.quiz.active) {
						store.commit(mutationTypes.quizEnd, {});
					}
				}
			});
		},
	],
};
